<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>lblEditDealerParts</div>
        <div class="float-right">
          <a class="close mr-3" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
            </a>
        </div>
      </div>
      <form [formGroup]="editDealerPartsForm" (ngSubmit)="updateDealerParts()">
        <div class="scrollbar">
          <div class="card-content">
            <div class="card-body p-0">
              <div class="form-row">
                <div class="col-6 af-form-group">
                  <!-- Dealer Selection drop down  -->
                  <label for="service" translate>lblSelectDealer</label>
                  <div class='lbl-info'>
                    <ng-select formControlName="dealerName" placeholder="{{ 'lblSelectDealer' | translate }}" readonly
                      [(ngModel)]="SelectedDealer" (change)="getDealerPartsList()">
                      <ng-option *ngFor="let category of dealerList" [value]="category.value">
                        {{category.text}}</ng-option>
                    </ng-select>
                    <div *ngIf="cpf.dealerName.invalid && (cpf.dealerName.dirty || cpf.dealerName.touched)"
                      class="help-block text-danger">
                      <div *ngIf="cpf.dealerName.errors.required"><span translate>lblDealerRequired</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-6 af-form-group">
                  <!-- PartNumber drop down -->
                  <label for="service" translate>lblPartNumber</label>
                  <div class='lbl-info'>
                    <ng-select formControlName="partNumber" placeholder="{{ 'lblSelectPartNumber' | translate }}"
                      readonly [(ngModel)]="SelectedParts">
                      <ng-option *ngFor="let category of partsList" [value]="category.id" disabled="disabled">
                        {{category.partNumber}}</ng-option>
                    </ng-select>
                    <div *ngIf="cpf.partNumber.invalid && (cpf.partNumber.dirty || cpf.partNumber.touched)"
                      class="help-block text-danger">
                      <div *ngIf="cpf.partNumber.errors.required"><span translate>lblPartNumbeRrequired</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-6 af-form-group"[hidden]='true'>
                  <!-- Convert to Part number -->
                  <label for="service" translate>lblConvertToPartNumber</label>
                  <div class='lbl-info'>
                    <input formControlName="convertToPartNumber" class="form-control mb-2" readonly
                      [ngClass]="{'is-invalid': cpf.convertToPartNumber.invalid && cpf.convertToPartNumber.touched}">
                    <div
                      *ngIf="cpf.convertToPartNumber.invalid && (cpf.convertToPartNumber.dirty || cpf.convertToPartNumber.touched)"
                      class="help-block mt-1 text-danger"> <em class="ft-alert-circle align-middle"
                        aria-hidden="true"></em>
                      <span translate>lblConvertToPartNumberRequired</span>
                    </div>
                  </div>
                </div>
                <div class="col-6 af-form-group">
                  <!-- Quantity -->
                  <label for="convertToPartNumber" translate>lblQuantity <span class="required">*</span></label>
                  <div class='lbl-info'>
                    <input formControlName="quantity" class="form-control mb-2" pattern="^(0|[1-9][0-9]*)$"
                      placeholder="{{ 'lblEnterQuantity' | translate }}" required maxlength="10"
                      [ngClass]="{'is-invalid': cpf.quantity.invalid && cpf.quantity.touched}">
                    <div *ngIf="cpf.quantity.invalid && (cpf.quantity.dirty || cpf.quantity.touched)"
                      class="help-block mt-1 text-danger"> <em class="ft-alert-circle align-middle"
                        aria-hidden="true"></em>
                      <div *ngIf="cpf.quantity.errors.required"><span translate>lblQuantityRequired</span></div>
                      <div *ngIf="cpf.quantity.errors.pattern"><span translate>lblOnlyNumbersAreAllowed</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-6 af-form-group">
                  <!-- UnitPrice -->
                  <label for="service" translate>lblUnitPrice <span class="required">*</span></label>
                  <div class='lbl-info'>
                    <input type="text" formControlName="unitPrice" class="form-control" placeholder="Enter unit price"
                      pattern="^[\d,.\s]+$" required maxlength="10" [ngModel]="unitPrice | number:'1.2-2'"
                      (blur)="onBlur($event)"
                      [ngClass]="{'is-invalid': cpf.unitPrice.invalid && cpf.unitPrice.touched}">
                    <div *ngIf="cpf.unitPrice.invalid && (cpf.unitPrice.dirty || cpf.unitPrice.touched)"
                      class="help-block text-danger">
                      <div *ngIf="cpf.unitPrice.errors.required"><span translate>lblUnitPriceRequired</span></div>
                      <div *ngIf="cpf.unitPrice.errors.pattern"><span translate>lblProperValue</span></div>
                      <div *ngIf="cpf.unitPrice.errors.unitPriceFlag"><span translate>lblUnitPriceMessage</span></div>
                    </div>
                  </div>
                </div>
                <div class="col-6 af-form-group">
                  <label>&nbsp;</label>
                  <div class="lbl-info">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input" id="isActive" formControlName="isActive">
                      <label class="custom-control-label" for="isActive" translate>lblActive</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p-3 bg-light pp-footer-top-brdr">
        <div class="row">
          <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
            <button type="submit" class="btn btn-primary mr-sm-2 btn-lg" aria-label="Center Align" [disabled]="!editDealerPartsForm.valid"
              translate>lblSaveChanges</button>
            <a (click)="OnClose()"  class="btn btn-secondary btn-lg" translate>lblCancel</a>
          </div>
        </div>
      </div>
      </form>
    </div>
  </div>
</div>